import { HttpHeaders } from '@angular/common/http';
import { merge } from 'lodash';
import { catchError, forkJoin, map, of, tap } from 'rxjs';
/**
 * use to load translations from multiple sources e.g.
 *
 *     export class GeaHttpLoaderFactory(http: HttpClient) {
 *       return new GeaTranslateHttpLoader(http, environment.localizationStorageURL, ['i18n/1/portal/'], ['assets/i18n/']);
 *     }
 *      @NgModule({
 *      imports: [
 *        TranslateModule.forRoot({
 *          extend: true,
 *          defaultLanguage: 'en-US',
 *          loader: {
 *             deps: [HttpClient],
 *             provide: TranslateLoader,
 *             useFactory: GeaHttpLoaderFactory,
 *          },
 *        }),
 *     ]});
 */
export class GeaTranslateHttpLoader {
  http;
  storageUrl;
  storagePaths;
  absolutePaths;
  suffix;
  defaultLang;
  defaultTranslations = {};
  devLang = 'dv-DV';
  constructor(http, storageUrl, storagePaths, absolutePaths = [], suffix = '.json', defaultLang = 'en-US') {
    this.http = http;
    this.storageUrl = storageUrl;
    this.storagePaths = storagePaths;
    this.absolutePaths = absolutePaths;
    this.suffix = suffix;
    this.defaultLang = defaultLang;
    // include common storagePath by default
    if (!storagePaths.find(path => /\/common\//gi.test(path))) {
      this.storagePaths.push('i18n/1/common/');
    }
  }
  /**
   * Gets the translations from the server - for multiple sources
   */
  getTranslation(lang) {
    return this.getTranslations(lang);
  }
  getTranslations(lang) {
    if (lang === this.devLang) {
      return of({});
    }
    const noCacheHeaders = new HttpHeaders({
      'Cache-Control': 'no-cache'
    });
    return forkJoin(this.storagePaths.map(storagePath => this.storageUrl + storagePath + lang + this.suffix).concat(this.absolutePaths.map(absolutePath => absolutePath + lang + this.suffix)).map(path => this.http.get(path, {
      headers: noCacheHeaders
    }).pipe(catchError(error => {
      // eslint-disable-next-line no-console
      console.error('Error loading translations for ' + lang, error);
      return of({});
    })))).pipe(tap(translations => this.setDefaultTranslation(translations, lang)), map(translations => this.addDefaultTranslations(translations)),
    // concat all translations
    map(translations => this.concatTranslations(translations)));
  }
  /**
   * sets and caches the defaultTranslation
   * @param translations
   * @param lang
   */
  setDefaultTranslation(translations, lang) {
    if (lang === this.defaultLang) {
      // the default language will always be loaded first, so we can use it as fallback
      this.defaultTranslations = this.concatTranslations(translations);
    }
  }
  /**
   * adds the defaultTranslation in front of the list of translations so they ca nbe used as fallback
   * @param translations
   * @param lang
   * @private
   */
  addDefaultTranslations(translations) {
    return [this.defaultTranslations, ...translations]; // pad with english translations as fallback
  }
  /**
   * merge multiple translations sources into one
   * @param translations
   * @private
   */
  concatTranslations(translations) {
    return translations.reduce((acc, translations) => merge(acc, translations), {});
  }
}
